import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ totalPages, currentPage, paginate }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center mt-6 space-x-2">
      <button
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
        className={`p-2 rounded-md ${
          currentPage === 1 
            ? 'text-gray-400 cursor-not-allowed'
            : 'text-[#202654] hover:bg-[#202654]/10'
        }`}
        aria-label="Page précédente"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>
      
      <div className="flex space-x-1">
        {[...Array(totalPages)].map((_, index) => {
          const pageNumber = index + 1;
          // Show first page, last page, current page, and pages around current page
          if (
            pageNumber === 1 ||
            pageNumber === totalPages ||
            (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
          ) {
            return (
              <button
                key={pageNumber}
                onClick={() => paginate(pageNumber)}
                className={`h-8 w-8 flex items-center justify-center rounded-md ${
                  currentPage === pageNumber
                    ? 'bg-[#202654] text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                {pageNumber}
              </button>
            );
          } else if (
            (pageNumber === 2 && currentPage > 3) ||
            (pageNumber === totalPages - 1 && currentPage < totalPages - 2)
          ) {
            // Show ellipsis
            return <span key={pageNumber} className="px-1 text-gray-500">...</span>;
          }
          return null;
        })}
      </div>
      
      <button
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`p-2 rounded-md ${
          currentPage === totalPages 
            ? 'text-gray-400 cursor-not-allowed'
            : 'text-[#202654] hover:bg-[#202654]/10'
        }`}
        aria-label="Page suivante"
      >
        <ChevronRight className="h-5 w-5" />
      </button>
    </div>
  );
};

export default Pagination; 